module.exports = __webpack_public_path__ + "static/media/final-j-171-bet-el-watan-shot-1.d9cfda24.webp";